/* eslint-disable prettier/prettier */
export const InvitationTableHeader = ({ isSuperAdmin }: { isSuperAdmin: boolean }) => (
  <div className="flex items-center px-4 py-3 font-semibold border text-md sm:w-[90%] bg-gray-50 text-muted-foreground">
    <div className={`${isSuperAdmin ? 'w-[25%]' : 'w-[30%]'} `}>Email</div>
    {isSuperAdmin && <div className="w-[20%] ">Company</div>}
    <div className="w-[20%]">Role</div>
    <div className={`${isSuperAdmin ? 'w-[20%]' : 'w-[25%]'} `}>Invited By</div>
    <div className={`${isSuperAdmin ? 'w-[10%]' : 'w-[20%]'} `}>Status</div>
    <div className="w-[5%] text-right"></div>
  </div>
);
